import App from './App'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import store from './store/store.js'
import { SnackbarProvider } from 'notistack'
import { Slide } from '@mui/material'

let container = document.getElementById('container')
const root = ReactDOM.createRoot(container)

function SlideTransition(props) {
	return <Slide {...props} direction='up' />
}

root.render(
	<Provider store={store}>
		<SnackbarProvider
			maxSnack={3}
			anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
			TransitionComponent={SlideTransition}
			autoHideDuration={8000}
		>
			<App />
		</SnackbarProvider>
	</Provider>
)
